import {
  COMPETITION_REGISTRATIONS,
  COMPETITION_REGISTER,
  UPDATE_RACECLASS,
  UPDATE_REGISTRATION,
  TOGGLE_STARTLIST,
  TOGGLE_MULTIPLE_STARTLIST,
  LIST_VEHICLE_BRANDS,
} from './config';

export async function getRegistrations(id) {
  const url = COMPETITION_REGISTRATIONS.replace('{competitionId}', id);
  const token = localStorage.getItem('token');

  const registrations = await fetch(url, {
    headers: {
      Authorization: 'Bearer ' + token,
      'Content-Type': 'application/json',
    },
  })
    .then((res) => {
      if (res.ok) {
        return res.json();
      } else {
        throw new Error('Kunde inte hämta anmälda deltagare');
      }
    })
    .then((data) => {
      return data;
    })
    .catch((err) => {
      //console.error(err);
    });

  return registrations;
}

export async function getVehicleBrands() {
  // missing endpoint in be;

  return ['placeholder-vehicle-brand'];

  const url = LIST_VEHICLE_BRANDS;
  const token = localStorage.getItem('token');

  const vehicleBrands = await fetch(url, {
    headers: {
      Authorization: 'Bearer ' + token,
    },
  })
    .then((res) => {
      if (res.ok) {
        return res.json();
      } else {
        throw new Error('Kunde inte hämta fordonstillverkare');
      }
    })
    .then((data) => {
      return data?.vehicleBrands;
    })
    .catch((err) => {
      //console.error(err);
    });

  return vehicleBrands;
}

export async function addRegistration(competitionId, values) {
  const url = COMPETITION_REGISTER;
  const token = localStorage.getItem('token');

  //let success = false;
  let supporterNull = true;

  let data = {};
  Object.assign(data, values);
  if (data.lotsId) {
    data.lotsId = parseInt(data.lotsId);
  }
  //Check if supporter contains values other than empty strings
  let supporterValues = Object.values(data['supporter']);
  for (let i = 0; i < supporterValues.length; i++) {
    if (supporterValues[i] !== '') {
      supporterNull = false;
    }
  }

  if (supporterNull) {
    data['supporter'] = null;
  }

  //Add key-value for competitionId
  data['competitionId'] = competitionId;

  let result = await fetch(url, {
    method: 'POST',
    headers: {
      Authorization: 'Bearer ' + token,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((data) => {
      // if (data.statusCode === 200) {
      //   success = true;
      // }
      // return;
      return data;
    })
    .catch((err) => {
      //console.error(err);
    });

  return result;
}

export async function updateRaceClass(
  competitionId,
  raceClass,
  participantIds,
  emails
) {
  const url = UPDATE_RACECLASS;
  const token = localStorage.getItem('token');

  let data = {
    competitionId: competitionId,
    raceClass: raceClass,
    participantIds: participantIds,
    emails: emails,
  };

  let resultData = await fetch(url, {
    method: 'PUT',
    headers: {
      Authorization: 'Bearer ' + token,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      if (res.ok) {
        return res.json();
      }
      throw new Error('Error updating raceClass');
    })
    .then((data) => {
      return data;
    })
    .catch((err) => {
      //console.error(err);
    });

  return resultData;
}

export async function updateRegistration(
  competitionId,
  unRegistered,
  participantIds,
  emails
) {
  const url = UPDATE_REGISTRATION;
  const token = localStorage.getItem('token');

  const data = {
    competitionId: competitionId,
    unregister: !unRegistered,
    participantIds: participantIds,
    emails: emails,
  };

  const result = await fetch(url, {
    method: 'PUT',
    headers: {
      Authorization: 'Bearer ' + token,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      if (res.ok) {
        return res.json();
      } else if (res.status === 409) {
        return {
          statusCode: 409,
          errorMessage:
            'Kunde inte avanmäla de valda objekten på grund av att en eller flera av dem finns i startlistan.',
        };
      }
      throw new Error('Error updating raceClass');
    })
    .then((data) => {
      return data;
    })
    .catch((err) => {
      // console.error(err);
    });

  return result;
}

export async function toggleStartlist(
  competitionId,
  participantId,
  email,
  inStartlist
) {
  const url = TOGGLE_STARTLIST;
  const token = localStorage.getItem('token');
  let data = {};

  if (participantId) {
    data = {
      competitionId: competitionId,
      participantId: participantId,
      inStartlist: inStartlist,
    };
  } else {
    data = {
      competitionId: competitionId,
      email: email,
      inStartlist: inStartlist,
    };
  }

  const status = await fetch(url, {
    method: 'POST',
    headers: {
      Authorization: 'Bearer ' + token,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      if (res.ok) {
        return res.json();
      }
      throw new Error('Error adding participant to startlist');
    })
    .then((data) => {
      return data.statusCode;
    })
    .catch((err) => {
      //console.error(err);
    });

  return status;
}

export async function toggleMultipleStartlist(
  competitionId,
  participants,
  inStartlist
) {
  const url = TOGGLE_MULTIPLE_STARTLIST;
  const token = localStorage.getItem('token');

  const participantIds = participants
    .filter((p) => p.participantId)
    .map((p) => p.participantId);

  const emails = participants
    .filter((p) => p.participantDetails.email && !p.participantId)
    .map((p) => p.participantDetails.email);

  const data = {
    CompetitionId: competitionId,
    emails: emails,
    participantIds: participantIds,
    inStartlist: inStartlist,
  };

  const status = await fetch(url, {
    method: 'POST',
    headers: {
      Authorization: 'Bearer ' + token,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((data) => {
      return data;
    })
    .catch((err) => {
      // console.error(err);
    });

  return status;
}
